<template>
  <div>
    <my-notification :icon="'warning'">
      <template #title>
        {{ $t('compEcolabwareDocsNotes.title-1') }}
      </template>
    </my-notification>
    <br />
    <b-notification :closable="false">
      <b>{{ $t('compEcolabwareDocsNotes.title-2') }}</b>
      <br />
      <span v-html="$t('compEcolabwareDocsNotes.desc-1')" />
    </b-notification>
    <b-notification :closable="false">
      <b>{{ $t('compEcolabwareDocsNotes.title-3') }}</b>
      <br />
      <span v-html="$t('compEcolabwareDocsNotes.desc-2')" />
      <ul style="list-style-type: square; margin-left: 25px">
        <li><span v-html="$t('compEcolabwareDocsNotes.desc-3')" /></li>
        <li><span v-html="$t('compEcolabwareDocsNotes.desc-13')" /></li>
        <li><span v-html="$t('compEcolabwareDocsNotes.desc-4')" /></li>
        <li><span v-html="$t('compEcolabwareDocsNotes.desc-14')" /></li>
        <li><span v-html="$t('compEcolabwareDocsNotes.desc-5')" /></li>
        <li><span v-html="$t('compEcolabwareDocsNotes.desc-6')" /></li>
        <li><span v-html="$t('compEcolabwareDocsNotes.desc-7')" /></li>
        <li><span v-html="$t('compEcolabwareDocsNotes.desc-8')" /></li>
      </ul>
    </b-notification>
    <b-notification :closable="false">
      <b>{{ $t('compEcolabwareDocsNotes.title-4') }}</b>
      <br />
      <span v-html="$t('compEcolabwareDocsNotes.desc-9')" />
      <ul style="list-style-type: square; margin-left: 25px">
        <li><span v-html="$t('compEcolabwareDocsNotes.desc-10')" /></li>
        <li><span v-html="$t('compEcolabwareDocsNotes.desc-15')" /></li>
        <li><span v-html="$t('compEcolabwareDocsNotes.desc-11')" /></li>
        <li><span v-html="$t('compEcolabwareDocsNotes.desc-12')" /></li>
      </ul>
    </b-notification>
  </div>
</template>

<script>
export default {
  name: 'Notes',
  components: {
    'my-notification': () => import('@/components/MyNotification.vue')
  }
}
</script>
